import { Device } from '@/store/device/types';
import { Prices } from '@/store/prices/types';
import isFirstMonthCoupon from '@/utils/prices/isFirstMonthCoupon';
import isUSPricing from '@/utils/prices/isUSPricing';

export type ActiveOffer =
	| { type: 'firstMonth'; couponId: string; price: number }
	| { type: 'percentOff'; couponId: string; percentOff: number };

export type ActiveOfferType = ActiveOffer['type'];

export const getActiveOffer = (
	prices: Prices | undefined | null,
	device: Device | undefined | null,
): ActiveOffer | null => {
	const monthly = prices?.coupons?.monthly;
	const firstMonthPrice = prices?.current?.monthly;
	// The first-month offer is only priced for the US. The experiment should never assign it
	// elsewhere, so this guards against a misconfigured arm rather than routing users.
	if (isFirstMonthCoupon(monthly) && typeof firstMonthPrice === 'number' && isUSPricing(prices, device)) {
		return { type: 'firstMonth', couponId: monthly.id, price: firstMonthPrice };
	}
	const yearly = prices?.coupons?.yearly;
	if (typeof yearly?.percent_off !== 'undefined') {
		return { type: 'percentOff', couponId: yearly.id, percentOff: yearly.percent_off };
	}
	return null;
};
